<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-08-22 17:10:30
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-23 17:32:37
-->
<template>
	<div class="accountDrawer">
		<el-drawer :title="title" :visible.sync="drawer" :wrapperClosable="false" @closed="handleClose" ref="drawer" size="724px">
			<div class="p-24" v-loading="loading">
				<el-form :model="form" :rules="rules" ref="accountForm">
					<p class="yx-pingfang-semibold yx-color-black1 font-h4-regular mb-20">用户信息</p>
					<el-form-item label="用户昵称" prop="nickname" label-width="100px">
						<el-input v-model="form.nickname" maxlength="10" placeholder="请填写" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="登录手机号" prop="mobile" class="mobile" label-width="100px">
						<el-input v-model="form.mobile" placeholder="请填写" :disabled="mobileIsabled" maxlength="11"></el-input>
						<span class="font-h6-regular yx-color-text-secondary">
							提示：{{ title == '新增账号' ? '添加后' : '修改后' }}，员工使用【手机号+验证码】即可登录
						</span>
					</el-form-item>
					<el-form-item label="用户类型" prop="userType" label-width="100px">
						<el-select v-model="form.userType" placeholder="请选择" multiple class="width100">
							<el-option :label="item.name" :value="item.id" v-for="item in roleTypeList" :key="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="部门" prop="deptId" v-if="isShowUpDep" label-width="100px">
						<el-select v-model="form.deptId" placeholder="请选择" class="width100" :disabled="isDisable">
							<el-option :label="item.name" :value="item.id" v-for="item in depList" :key="item.id"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="备注" label-width="100px">
						<el-input v-model="form.remark" placeholder="请填写" show-word-limit maxlength="50"></el-input>
					</el-form-item>
					<el-form-item label="微信绑定信息" label-width="100px" v-if="editAcc">
						<div class="bindBox flex-row flex-wrap">
							<template v-if="bindList.length">
								<div class="item mr-16 mb-16 flex-row" v-for="(item, index) in bindList" :key="index">
									<div class="left font-h6-regular flex-row-align-center pt-6 pb-6">
										<yx-avatar :src="item.avatar" :size="24" class="ml-12" />
										<p class="ml-8">{{ item.nickName | textFormat(10) }}</p>
									</div>
									<div class="ml-12">
										<span class="fz-12 cursor-pointer color-p-4" @click="unbind(item)">解绑</span>
									</div>
								</div>
							</template>
							<div v-else>暂无微信绑定</div>
						</div>
					</el-form-item>
					<p class="yx-pingfang-semibold yx-color-black1 font-h4-regular mb-20">权限配置</p>
					<el-form-item label-width="80px" label="用户角色" prop="roleIds">
						<el-select
							v-model="form.roleIds"
							placeholder="请选择"
							class="width100 disable-bg"
							v-select="form.roleIds"
							:multiple="true"
							ref="roleSelect"
						>
							<template v-for="item in rolePullList">
								<el-option :label="item.name" :value="item.id" :key="item.id" :disabled="item.scopeType == 1 || item.disable"></el-option>
							</template>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label-width="100px">
						<div slot="label" class="flex-row">
							<Explain
								content="影响商品或订单是否为店铺权限内店铺的相关数据可见性，包括样品订单、商品管理、订单管理、团长管理及合作进度"
								placement="top"
								class="explain"
								classStyle="yx-color-text-regular"
							></Explain>
							<p class="ml-4">店铺权限</p>
						</div>
						<div class="fz-14 yx-color-text-primary">
							{{ shopContent }}
						</div>
					</el-form-item> -->
					<el-form-item label-width="100px">
						<div slot="label" class="flex-row">
							<Explain
								content="影响数据中关联的达人运营是否为部门权限内人员的数据可见性，包括人员管理、样品订单、订单管理、团长管理及合作进度"
								placement="top"
								class="explain"
								classStyle="yx-color-text-regular"
							></Explain>
							<p class="ml-4">部门权限</p>
						</div>
						<div class="flex-row flex-wrap" v-if="isShowDepAuth">
							<template v-if="depTagList.length">
								<p
									class="font-h6-regular yx-color-text-regular mt-6 yx-border pr-6 pl-6 pb-2 mr-8 radius-2 mb-8"
									v-for="(item, index) in depTagList"
									:key="index"
								>
									{{ item }}
								</p>
							</template>
							<p v-else>-</p>
						</div>
						<div class="yx-color-text-secondary" v-else>请先选择用户角色及部门</div>
					</el-form-item>
				</el-form>
				<div class="mt-30" v-if="isShowFunAuth">
					<div class="flex-row-align-center font-h4-regular yx-color-text-regular">
						<Explain content="影响菜单及按钮的可见性" placement="top" class="explain" classStyle="yx-color-text-regular"></Explain>
						<p class="ml-4">功能权限</p>
					</div>
					<el-table class="mt-16" header-row-class-name="table-header-row" row-class-name="table-row" :data="tableData">
						<el-table-column prop="name" label="菜单功能" width="180"></el-table-column>
						<el-table-column label="权限">
							<template slot-scope="{ row }">
								<div class="flex-row-align-center">
									<img src="@/assets/public/success.png" style="width: 14px" alt="" />
									<span class="font-h4-regular yx-color-text-regular ml-4">{{ row.power }}</span>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="mt-30 flex-row-align-center" v-else>
					<div class="flex-row-align-center font-h4-regular yx-color-text-regular">
						<Explain content="影响菜单及按钮的可见性" placement="top" class="explain" classStyle="yx-color-text-regular"></Explain>
						<p class="ml-4">功能权限</p>
					</div>
					<div class="yx-color-text-secondary font-h4-regular ml-12">请先选择用户角色</div>
				</div>
			</div>
			<div class="demo-drawer__footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="save()">保存</el-button>
			</div>
		</el-drawer>
		<unbind ref="unbind" @Refresh="getBindList" />
		<no-other-tip ref="noOtherTip" />
		<other-tip ref="otherTip" @refresh="subeditAct" />
		<!-- 删除成员弹窗 -->
		<del-account ref="delAccount" />
	</div>
</template>

<script>
import { validateTel } from '@/utils/validate';
import {
	saveAddAccount,
	getDepName,
	subeditAct,
	getRoleDownList,
	managerDeptlistByScope,
	getRoleMenuPower,
	getAllMenuPower,
	getPartnerList,
	mobileCheck,
	checkUserTalentPermission,
	wxBindList,
	accountCheckDel,
} from '@/api/teamManage';
import Explain from '@/components/common/explain';
import throttle from 'lodash/throttle';
import { zsRoleType, drRoleType, tzRoleType } from '@/utils/dataMap';
const handleFormWatch = function (to, form) {
	const { deptId, roleIds = [], userType = [] } = this.form;
	if (deptId && roleIds.length) {
		this.managerDeptlistByScope(deptId, roleIds);
		this.isShowDepAuth = true;
	} else {
		this.isShowDepAuth = false;
	}
	if (roleIds.length) {
		this.getRoleMenuPower(roleIds, userType);
		this.isShowFunAuth = true;
	} else {
		this.isShowFunAuth = false;
	}
};
export default {
	components: {
		Explain,
		unbind: () => import('./components/unbind.vue'),
		noOtherTip: () => import('./components/noOtherTip'),
		otherTip: () => import('./components/otherTip'),
		delAccount: () => import('../delAccount'),
	},
	data() {
		return {
			title: '',
			status: 0,
			drawer: false,
			direction: '',
			form: { nickname: '', mobile: '', roleIds: [], deptId: '', remark: '', userType: [], status: '1' },
			disabledSave: true,
			//新增子部门相关
			parentDepName: '', //上级部门名称（编辑部门的时候）
			parentDep: '', //上级部门
			isShowUpDep: false,
			id: 0,
			isDisable: false,
			loading: false,
			//编辑账号相关
			depList: [],
			rolePullList: [],
			mobileIsabled: false,
			rules: {
				nickname: [
					{ required: true, message: '请填写用户昵称', trigger: 'blur' },
					{ min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' },
				],
				mobile: [{ required: true, validator: validateTel, trigger: 'blur' }],
				roleIds: [{ required: true, message: '请选择角色', trigger: 'change' }],
				deptId: [{ required: true, message: '请选择所属部门', trigger: 'change' }],
			},
			tableData: [],
			// 数据字典
			roleTypeList: [zsRoleType, drRoleType],
			isShowDepAuth: false,
			isShowFunAuth: false,
			menuList: [],
			originData: [],
			depTagList: [],
			bindList: [],
			oldMobile: '',
		};
	},

	directives: {
		select: {
			update: function (el) {
				// 不加演示器会出现第一次不触发问题
				setTimeout(() => {
					const domSelect = el.children[0].children[0];
					var selectList = Array.from(domSelect.children);
					selectList.forEach(item => {
						item.children[1].style.display = 'none';
					});
				}, 0);
			},
		},
	},
	props: {},
	computed: {
		// shopContent() {
		// 	const { userType = [] } = this.form;
		// 	//只有为店铺运营时展示请前往
		// 	return userType[0] === `${zsRoleType.id}` && userType.length === 1 ? '请前往店铺管理-人员设置中，设置该人员所管理的店铺' : '可查看所有店铺数据';
		// },
		//新增账号
		addAcc({ status }) {
			return status === 1;
		},
		//编辑账号
		editAcc({ status }) {
			return status === 2;
		},
	},
	watch: {
		'form.roleIds': {
			handler: handleFormWatch,
			deep: true,
		},
		'form.deptId': {
			handler: handleFormWatch,
			deep: true,
		},
		'form.userType': {
			handler: handleFormWatch,
			deep: true,
		},
	},
	methods: {
		show(val, actObj) {
			//val为1代表新增账号，为2代表编辑账号，3为重置账号,act代表账号
			this.title = val == 1 ? '新增账号' : '编辑账号';
			this.status = val;
			if (val == 1) {
				this.isShowUpDep = true;
				this.addAccount(actObj?.id);
			} else {
				this.id = actObj?.id;
				this.oldMobile = actObj?.mobile;
				this.isShowUpDep = actObj?.role?.every(v => v.scopeType !== 1);
				this.editAct(actObj);
				this.getBindList();
			}
			this.getPartnerList();
			this.getAllMenuPower();
			this.drawer = true;
		},
		save: throttle(function () {
			this.$refs.accountForm.validate(async valid => {
				if (valid) {
					// 当前子账号角色包含“仅针对达人运营生效”的权限，且用户没选择 达人运营 用户类型，展示此弹窗，否则走原逻辑，需要后端提供查询当前角色包含权限接口，希望传入指定权限id，返回布尔值
					const { userType = [], roleIds } = this.form;
					const { data, code } = await checkUserTalentPermission({
						userTypes: userType.length ? userType : [],
						roleIds: roleIds,
					});
					if (code !== 0) return;
					if (!data) {
						this.$confirm(
							'所选用户角色中，包含仅针对达人运营生效的权限。建议在【用户类型】处勾选【达人运营】，否则将导致子账号此部分权限失效。是否仍要创建？',
							'提示',
							{
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning',
							},
						)
							.then(() => {
								this.handleConfirm();
							})
							.catch(() => {});
					} else {
						this.handleConfirm();
					}
				}
			});
		}, 1000),
		handleConfirm() {
			if (this.status === 1) {
				this.saveAddAccount();
			} else {
				if (this.oldMobile === this.form.mobile) return this.subeditAct();
				this.mobileCheck();
			}
		},
		//新增账号val=1时
		addAccount() {
			this.getRolePullList();
		},
		//新增账号保存val=1时
		async saveAddAccount() {
			const { userType = [] } = this.form;
			await saveAddAccount({ ...this.form, userType: userType.length ? userType : [] });
			this.$emit('refresh');
			this.$message.success('添加成功');
			this.drawer = false;
		},
		// 校验用户类型是否改变，如果减少了某个用户类型 需要进行check看是否有没有完结的工作（招商是商品 达人运营是达人）
		async checkUserType() {
			const { userType = [] } = this.form;
			if (!this.prevUserType || this.prevUserType.length == 0) {
				return true;
			}

			const delArr = [];
			this.prevUserType.forEach(item => {
				if (!userType.includes(item)) {
					delArr.push(+item);
				}
			});

			if (delArr.length > 0) {
				const data = await accountCheckDel({ userId: this.id, userType: delArr });
				let isCanDel = true;
				isCanDel = !data.code;
				if (isCanDel) {
					return true;
				}

				const delAccountUserType = [];
				if (delArr.includes(drRoleType.id) && (Number(data.anchorTotal) > 0 || Number(data.institutionTotal) > 0)) {
					delAccountUserType.push(drRoleType.id);
				}

				if (delArr.includes(zsRoleType.id) && Number(data.productTotal) > 0) {
					delAccountUserType.push(zsRoleType.id);
				}
				if (delAccountUserType.length) {
					this.$refs.delAccount.show(delAccountUserType, isCanDel, { userId: this.id }, data, true);
					return false;
				}
			}
			return true;
		},
		//编辑账号后提交
		async subeditAct() {
			let tf = await this.checkUserType();
			if (tf) {
				const { userType = [] } = this.form;
				let subform = {
					...this.form,
					id: this.id,
					userType: userType.length ? userType : [],
				};
				await subeditAct(subform);
				this.$emit('refresh');
				this.$message.success('编辑成功');
				this.drawer = false;
			}
		},
		async mobileCheck() {
			const { oldMobile, form, id: userId } = this;
			const { checkResult, wxNickName } = await mobileCheck({ originalMobile: oldMobile, mobile: form.mobile, userId });
			if (checkResult === 0) this.subeditAct(); //检查通过
			if (checkResult === 1) this.$refs.otherTip.show(wxNickName, oldMobile); //不存在其他租户绑定
			if (checkResult === 2) this.$refs.noOtherTip.show(wxNickName); //存在其他租户绑定
		},
		//编辑账号且有管理员
		async editAct(actObj) {
			//初始化
			this.loading = true;
			this.mobileIsabled = false;
			await this.getRolePullList();
			this.form.nickname = actObj?.nickname;
			this.form.mobile = actObj?.mobile;
			this.form.roleIds = actObj?.role?.map(item => item.id);
			this.form.deptId = actObj?.deptId;
			this.form.remark = actObj?.remark;
			this.form.status = actObj?.status;
			this.form.userType = actObj?.userTypes?.filter(v => v.type !== tzRoleType.id)?.map(item => item.type);
			this.prevUserType = actObj?.userTypes?.filter(v => v.type !== tzRoleType.id)?.map(item => item.type);
			this.loading = false;
		},

		//编辑账号中获取下拉列表
		async getRolePullList() {
			this.depList = await getDepName();
			this.rolePullList = await getRoleDownList();
		},
		async getBindList() {
			const { id } = this;
			const data = await wxBindList({ userId: id });
			this.bindList = data;
		},
		async managerDeptlistByScope(deptId, roleIds) {
			const data = await managerDeptlistByScope({ deptId, roleIds });
			this.depTagList = [];
			data.forEach(item => {
				this.depTagList.push(this.getDepName(item.parentId, [], item.name));
			});
		},
		getDepName(parentId, arr = [], name) {
			if (name) {
				arr.push(name);
			}
			for (let key in this.originData) {
				let item = this.originData[key];
				if (item.id == parentId) {
					arr.push(item.name);
					this.getDepName(item.parentId, arr, '');
				}
			}
			let arr1 = JSON.parse(JSON.stringify(arr));
			arr1.reverse();
			return arr1.join('/');
		},
		async getAllMenuPower() {
			this.menuList = await getAllMenuPower(); //获取所有的权限列表
		},
		async getRoleMenuPower(roleIds, userType) {
			let resultArr = [];
			let treeList = await getRoleMenuPower({ roleIds, userType }); //获取对应的id
			let arr = [];
			// 生成角色权限树
			const _menuList = this.arrayToTree(this.menuList, 0);
			// 将树形结构转为二级树形结构
			_menuList.forEach(item => {
				resultArr.push({ ...item, childrens: [] });
				this.treeToArray(item, resultArr);
			});
			// 判断二级树形是否有所有权限，如果当前的权限比全部的权限少，那么就没有全部权限
			resultArr.forEach(item => {
				arr.push({ name: item.name, childrens: [] });
				item.childrens.forEach(v => {
					if (treeList.includes(v.id)) {
						arr[arr.length - 1].childrens.push(v.name);
					} else {
						arr[arr.length - 1].flage = true; //如果不存在flage,那么代表所有权限
					}
				});
			});
			this.tableData = arr
				.map(item => ({ name: item.name, power: !item.flage ? '所有权限' : item.childrens.join('、') }))
				.filter(item => {
					return item.power != '' ? item : '';
				});
		},
		//多级树形结构转成二级树形结构
		treeToArray(obj, resultArr) {
			if (obj.children.length > 0) {
				obj.children.forEach(v => {
					resultArr[resultArr.length - 1].childrens.push(v);
					if (v.children.length > 0) return this.treeToArray(v, resultArr);
				});
			} else {
				resultArr[resultArr.length - 1].childrens.push(obj);
			}
		},
		async getPartnerList() {
			let data = await getPartnerList();
			this.originData = data; //赋值原始数据一维数组
		},
		//转换一维数组成树形数组
		arrayToTree(data, pid) {
			return data.filter(item => item.parentId === pid).map(item => ({ ...item, children: this.arrayToTree(data, item.id) }));
		},
		unbind({ bindId }) {
			this.$refs.unbind.show(this.id, bindId, this.bindList.length);
		},
		handleClose() {
			this.drawer = false;
			this.isShowUpDep = true;
			this.isDisable = false;
			this.form = { nickname: '', mobile: '', roleIds: [], deptId: '', remark: '', userType: [], status: '1' };
			this.isShowDepAuth = false;
			this.isShowFunAuth = false;
			this.$refs.accountForm.resetFields();
		},
	},
};
</script>
<style lang="less" scoped>
.accountDrawer {
	/deep/ .el-drawer__header span {
		font-size: 14px;
	}
	/deep/ .el-table td.el-table__cell {
		color: #1d2129;
		font-size: 14px;
	}
	/deep/ .el-drawer__body {
		margin-bottom: 64px;
	}
	/deep/ .el-cascader {
		width: 100%;
	}
	.bindBox {
		.item {
			.left {
				border: 1px solid #eaebf0;
				width: 220px;
				border-radius: 4px;
			}
			.tag {
				height: 18px;
				line-height: 18px;
				border-radius: 2px;
				text-align: center;
				font-size: 12px;
				background-color: #fef3e7;
				color: #fa8f14;
				padding: 1px 3px;
			}
		}
	}
}
.disable-bg {
	/deep/ .el-input.is-disabled .el-input__inner {
		background-color: @color-gy3;
	}
}
/deep/ .el-form-item__label {
	padding-right: 8px;
}
/deep/ .el-form-item--small.el-form-item {
	margin-bottom: 24px;
}
.demo-drawer__footer {
	background: #ffffff;
	box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
	position: fixed;
	bottom: 0px;
	width: 724px;
	height: 64px;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	z-index: 999;
	&/deep/.el-button + .el-button {
		margin-right: 15px !important;
		margin-left: 16px !important;
		width: 88px;
	}
	&/deep/:first-child {
		width: 76px !important;
	}
}
/deep/ .mobile .el-form-item__error {
	position: absolute;
	top: 62% !important;
	left: 293px !important;
}
/deep/ .mobile.el-form-item--small.el-form-item {
	margin-bottom: 0px !important;
}
</style>
